export default "__VITE_ASSET__CMxWK5Xk__"